import { render, staticRenderFns } from "./PartCategory.vue?vue&type=template&id=3a6eb3b8&"
import script from "./PartCategory.vue?vue&type=script&lang=js&"
export * from "./PartCategory.vue?vue&type=script&lang=js&"
import style0 from "./PartCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports